import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cake, ChevronRight } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { useI18n } from "@/contexts/I18nContext";

export function CelebrationsBanner() {
  const { t } = useI18n();
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get("/admin/celebrations");
        if (!cancelled) setCount(data?.today?.total || 0);
      } catch (_) {} finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  if (loading || count === 0) return null;

  const c = t.admin.celebrationsPage;
  return (
    <Card
      className="rounded-2xl shadow-sm ring-1 ring-primary/20 overflow-hidden"
      data-testid="celebrations-dashboard-banner"
    >
      <div
        className="px-5 py-4"
        style={{
          background:
            "radial-gradient(700px circle at 90% 10%, rgba(200,30,58,0.12) 0%, transparent 55%), linear-gradient(180deg, hsl(var(--accent)) 0%, hsl(var(--card)) 100%)",
        }}
      >
        <div className="flex items-center gap-3">
          <div className="inline-flex h-11 w-11 items-center justify-center rounded-2xl bg-white ring-1 ring-black/5 text-primary">
            <Cake className="h-5 w-5" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="font-serif-display text-base font-semibold leading-tight">{c.bannerTitle}</p>
            <p className="text-sm text-muted-foreground">{c.bannerBody.replace("{n}", String(count))}</p>
          </div>
          <Button asChild size="sm" className="shrink-0" data-testid="celebrations-banner-cta">
            <Link to="/admin/celebrations">{c.bannerCta}<ChevronRight className="ml-1 h-4 w-4" /></Link>
          </Button>
        </div>
      </div>
    </Card>
  );
}
